import { withProps } from 'recompose';
import HeaderInner from '../../Header';

const Header = withProps({ product: 'dispositif Bailleur Privé' })(HeaderInner);

export default Header;
